<template>
  <div style="height:300px;">
    <div v-if="empty">
      <div class="py-3">You currently have no saved Quotations. To view our pricing, get a quotation.</div>
      <v-btn
        class="mt-6"
        color="primary"
        @click="openDrawer"
      >
        Get a Quote
      </v-btn>
    </div>
    <div v-else style="padding:10px">
      <div style="padding:10px 20px;background-color:beige;border-bottom: 1px solid #ccc;">
        <h5><b>My Quotations</b></h5>
      </div>
      <v-data-table
        :headers="headers"
        :items="quotes"
        :items-per-page="3"
        class="elevation-1"
      ></v-data-table>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  import axios from "axios";

  //const URL_COMP = "http://139.59.131.242:4000/comp/quotationsByClient";
  const URL_FTP = "http://139.59.131.242:4000/tp/quotationsByClient";
  export default {
    data () {
      return {
        empty: true,
        headers: [
          {
            text: 'Date',
            align: 'left',
            sortable: false,
            value: 'created_at',
          },
          { text: 'Product', value: 'product_type_id' },
          { text: 'Start', value: 'start_date' },
          { text: 'Expiry', value: 'end_date' },
          { text: 'Premium', value: 'total_premium_due' },
          { text: 'Currency', value: 'currency' },
        ],
        quotes:[]
      }
    },
    methods: {
      openDrawer(){
        this.components.nav_drawer.product_index=0;
        this.components.nav_drawer.mini_variant=false;
        this.components.nav_drawer.expand_on_hover=false;
        this.closeSheet();
      },
      closeSheet(){
        this.components.bottom_sheet.is_open=false;
        this.components.bottom_sheet.option_index=0;
      }
    },
    created(){
      
      const client_id = {
          id :this.user.data.client_id
      }

      //var URL = '';

      

      console.log(client_id);
        
      axios
        .get(URL_FTP, { params:client_id })
        .then(response => {
          console.log(response);
          if (response.status == 200){
            this.quotes = response.data;
            this.empty = false;
          }
        })
        .catch(error => {
          console.log('Error', error);
        }); 
    },
    computed: {
      ...mapGetters({
        user: "user",
        components: "components"
      })
    }
  }
</script>